import { LOCATION_CHANGE } from 'react-router-redux';

import * as organizationConstants from '../constants/organizations';
import * as bucketConstants from '../constants/buckets';
import * as assetConstants from '../constants/assets';


export function userSearch(state = { isAddMember: false }, action) {
    switch (action.type) {
        case LOCATION_CHANGE:
            // on url change set initial params
            return { isAddMember: false };
        case organizationConstants.TOGGLE_ADD_MEMBER:
            const { isAddMember } = action.payload;
            return {
                ...state,
                isAddMember,
                searchTerm: undefined,
                result: undefined,
            };
        case organizationConstants.USER_SEARCH_REQUEST:
            const { searchTerm } = action.payload;
            return {
                ...state,
                searchTerm,
                isSearching: true,
            };
        case organizationConstants.USER_SEARCH_SUCCESS:
            const { result } = action.payload;
            return {
                ...state,
                searchTerm,
                isSearching: false,
                result,
            };
        case organizationConstants.ADD_ORGANIZATION_MEMBERS_SUCCESS:
        case organizationConstants.INVITE_ORGANIZATION_MEMBER_SUCCESS:
            return {
                ...state,
                searchTerm: undefined,
                isSearching: false,
                result: undefined,
                isAddMember: false,
            };
        default:
            return state;
    }
}

export function searchOrganizationUsersForBucket(
    state = { isAddMember: false },
    action,
) {
    switch (action.type) {
        case LOCATION_CHANGE:
            // on url change set initial params
            return { isAddMember: false };
        case bucketConstants.TOGGLE_ADD_MEMBER:
            const { isAddMember } = action.payload;
            return {
                ...state,
                isAddMember,
            };
        case bucketConstants.ADD_BUCKET_MEMBERS_SUCCESS:
            return {
                ...state,
                isAddMember: false,
            };
        default:
            return state;
    }
}

export function assetSearch(
    state = {
        selectedTags: [],
        searchTerm: "",
    },
    action
) {
    switch (action.type) {
        case assetConstants.SET_ASSET_SEARCH_TERM:
            return {
                ...state,
                searchTerm: action.payload
            };
        case assetConstants.SET_ASSET_SEARCH_SELECTED_TAGS:
            return {
                ...state,
                selectedTags: action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/searchReducer.js